import React from 'react';
import { parse } from 'qs';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import Incidents from '../../containers/Incidents';
import { HomeReminders } from '../../components/HomeReminders';
import Statistics from '../../components/Statistics';
import { getRemindersTree } from '../../helpers/reminders';
import { PageTitleComponent } from '../../components/PageTitleComponent';

export default class HomePage extends React.PureComponent {
  componentDidMount() {
    const {
      getReminderList,
      getStatistic
    } = this.props;

    getReminderList();
    getStatistic();
  }

  render() {
    const {
      reminders: {
        reminderList
      },
      statistic,
      location,
      history
    } = this.props;    

    const params = parse(location.search, { ignoreQueryPrefix: true });
    const { type } = params;

    return (
      <React.Fragment>
        <PageTitleComponent/>
        <Header />
        <Incidents incidentType={type} history={history} />
        <HomeReminders reminders={getRemindersTree(reminderList)} />
        <Statistics statistic={statistic} />
        <Footer />
      </React.Fragment>
    );
  }
}
